import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as fileManagerActions from '../../actions';
import { getSelectedFolders, getSelectedNodeIDsInAllFolders } from '../../selectors/selectors';
import Checkbox from '../../../../../general/components/Checkbox/Checkbox';
import { FileManagerRow } from '../../model';
import { getBreadcrumbs } from '../../../breadcrumbs/selectors';

import { intersectionBy } from 'lodash';

const Connected: React.FC<{ rowData: FileManagerRow }> = ({ rowData }) => {
  const isChecked = useSelector(getSelectedNodeIDsInAllFolders).includes(rowData.id);
  const checkedFolders = useSelector(getSelectedFolders);
  const breadcrumbs = useSelector(getBreadcrumbs);

  const dispatch = useDispatch();
  const isCheckedByFolder = useMemo(() => {
    return intersectionBy(checkedFolders, breadcrumbs, (x) => x.id).length > 0;
  }, [checkedFolders, breadcrumbs]);
  return (
    <Checkbox
      isChecked={isChecked || isCheckedByFolder}
      disabled={isCheckedByFolder}
      label=""
      onChange={(isChecked, shift) =>
        dispatch(fileManagerActions.selectorChanged({ node: rowData, isChecked, shift }))
      }
    />
  );
};

export const SelectorCell = (props: { rowData: FileManagerRow }) => <Connected {...props} />;
